var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box, Button, Chip, Divider, Menu, MenuItem, Stack, } from "@vividtheory/minerva-lab";
import { ExpandMoreOutline } from "@vividtheory/minerva-lab/icons";
import { isEmpty, isNil } from "lodash";
import { useState } from "react";
import { v4 as uuid } from "uuid";
import { FilterInputField } from "../components/FilterInputField";
import { convertDataType, convertOperationText, matchOnchange, matchOperation, } from "../utils";
import React from "react";
import { ColFilterType, } from "../type";
export const FilterPanelContainer = ({ column, onSubmit, onClose, colFilterItem, }) => {
    const dataType = column.type;
    const initialOperator = matchOperation(convertDataType(dataType));
    const { operationType } = initialOperator, allFilter = __rest(initialOperator, ["operationType"]);
    const [localFilterData, setLocalFilterData] = useState((colFilterItem === null || colFilterItem === void 0 ? void 0 : colFilterItem.filterItem) || allFilter);
    const handleOperationChange = (input) => {
        matchOnchange("operation", input, localFilterData, setLocalFilterData);
    };
    const handleInputDataChange = (input) => {
        matchOnchange("data", input, localFilterData, setLocalFilterData);
    };
    const handleOnSubmit = () => {
        onSubmit({
            id: (colFilterItem === null || colFilterItem === void 0 ? void 0 : colFilterItem.id) || uuid(),
            columnName: (colFilterItem === null || colFilterItem === void 0 ? void 0 : colFilterItem.columnName) || column.field,
            label: (colFilterItem === null || colFilterItem === void 0 ? void 0 : colFilterItem.label) || column.headerName || column.field,
            filterItem: localFilterData,
        });
    };
    const disableCondition = localFilterData._type !== ColFilterType.boolean &&
        localFilterData._type !== ColFilterType.number &&
        (isEmpty(localFilterData.data) || isNil(localFilterData.data));
    return (React.createElement(Stack, { width: 52.5 },
        React.createElement(Stack, { gap: 1, width: "100%", sx: { padding: 2 } },
            React.createElement(Menu, { placement: "bottom-start", content: React.createElement(Stack, null, Object.values(operationType).map((option) => {
                    const typeOp = option;
                    return (React.createElement(MenuItem, { key: option, label: convertOperationText(option), density: "dense", onClick: () => {
                            handleOperationChange(typeOp);
                        }, selected: localFilterData.operation === option }));
                })) },
                React.createElement(Chip, { variant: "outlined", endNode: React.createElement(ExpandMoreOutline, null) }, convertOperationText(localFilterData.operation))),
            React.createElement(FilterInputField, { filters: localFilterData, handleInputDataChange: (d) => handleInputDataChange(d) })),
        React.createElement(Divider, null),
        React.createElement(Box, { sx: { padding: 2 } },
            React.createElement(Button, { fullWidth: true, disabled: disableCondition, onClick: () => {
                    handleOnSubmit();
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                } }, "Apply"))));
};
//# sourceMappingURL=FilterPanelContainer.js.map